// extracted by mini-css-extract-plugin
export default {"btnpwd":"ec52b4d87f"};